/**
 * Resolve image urls coming from the DB (admin panel stores them as
 * relative paths, e.g. "Coins_3.png" or "lootbox/icon_key_green.png").
 *
 * Bare coin icon filenames (Coins_N.png / icon_coin.png) are served from
 * /shop/coins/ — the re-sliced uniform 512×512 set — so admin configs keep
 * working without a DB change. Everything else resolves against public root.
 */
const COIN_ICON_RE = /^(Coins_\d+|icon_coin)\.png$/i;

export const normalizeShopImg = (url) => {
  if (!url) return null;
  if (url.startsWith('http') || url.startsWith('/')) return url;
  const clean = url.startsWith('./') ? url.slice(2) : url;
  if (COIN_ICON_RE.test(clean)) return `/shop/coins/${clean}`;
  return `/${clean}`;
};
